import styled from 'styled-components';
import logo from './../../_static/logo.png';

export const BackgroundHowWorks = styled.div`
    position: relative;
    width: 98%;
    max-width: 90%;
    margin: 30vh auto 60px;
    padding: 80px 20px 60px;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);

      .logo {
        background: url(${logo}) center center no-repeat;
        background-size: contain;
        height: 120px;
        min-width: 50px;
      }
    
        .title {
            text-align: left;
            height: 70px;
        }
        
        h2 {
            font-size: 40px;
            font-weight: normal;
        }
      
        t300.description {
          font-size: 10px;
          color:#DDD;
        }
      
        t400.contact {
          font-size: 8px;
          color:#DDD;
        }
  
`;